import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { KioskService } from "src/app/core/services/kiosk.service";
import { OOCanvasMenuItem } from "src/app/shared/models/oo-canvas-menu-item.model";

@Component({
	selector: "app-kiosk-menu-items",
	templateUrl: "./kiosk-menu-items.component.html",
	styleUrls: ["../../kiosk.styles.scss"],
})
export class KioskMenuItemsComponent implements OnInit, OnChanges {
	@Input() canvasKeySelected: number;
	@Input() canvasMenuItemSelected: OOCanvasMenuItem;
	@Output() canvasMenuItemSelectedEmitter = new EventEmitter<OOCanvasMenuItem>();

	canvasMenuItems: OOCanvasMenuItem[];
	canvasName: string;

	timestamp: number = new Date().valueOf();

	constructor(public kioskService: KioskService) {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.canvasKeySelected) {
			this.refreshCategoryItems();
		}
	}

	refreshCategoryItems() {
		const canvasSelected = this.kioskService.kioskMenu.find((canvas) => canvas.canvasKey === this.canvasKeySelected);
		this.canvasMenuItems = canvasSelected.menuItems;
		this.canvasName = canvasSelected.displayName || canvasSelected.name;
	}

	selectCanvasMenuItem(canvasMenuItem: OOCanvasMenuItem) {
		// this.kioskService.kioskOrderAddItem(canvasMenuItem);
	}
}
